import { h } from 'preact';
import * as BaseComp from 'components/bolt/footer/footer.js';

import { geoFromIP } from 'utils/bolt/geo';
import { renderCookieConsentLink } from 'utils/cookies';

import s from 'components/bolt/footer/footer.sss';

export default class Footer extends BaseComp.default {

	async componentDidMount() {
		super.componentDidMount();
		const geo = await geoFromIP();
		this.setState({ userCountry: geo?.countryCode });
	}

	renderLinks(items, type) {
		const { userCountry } = this.state;
		items = Object.fromEntries(Object.entries(items || {}).filter(([, val]) => (
			userCountry === 'us' ? !val?.nonUsOnly : !val?.usOnly
		)));
		return super.renderLinks(items, type);
	}

	renderLink(item, key, type) {
		if (this.getLinkUrl(item, type) === 'cookies') {
			return (
				<li class={s[`${type}Wrapper`]} key={key}>
					{renderCookieConsentLink(this.getLinkContent(item, type))}
				</li>
			);
		}
		return super.renderLink(item, key, type);
	}
}